import { LOCAL_STORAGE_TOKEN_KEY } from "./constants";
import Cookie from "js-cookie";
import React, { useContext } from "react";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

// Extend Window interface for runtime config
declare global {
  interface Window {
    APP_CONFIG?: {
      BASE_API_URL?: string;
    };
  }
}

export type Player = {
  id: number;
  name: string;
  is_admin: boolean;
  is_gm: boolean;
  is_agm: boolean;
  roles: string[];
};

export type JWTToken = {
  exp: number;
  discordId: string;
  player: Player;
};

type AuthContext = {
  loggedIn: boolean;
  setLoggedIn?: React.Dispatch<React.SetStateAction<boolean>>;
  player?: Player;
  setPlayer?: React.Dispatch<React.SetStateAction<Player | undefined>>;
  discordId?: string;
  setDiscordId?: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const LoginContext = React.createContext<AuthContext>({
  loggedIn: false,
});

export const LoginProvider = ({ children }: { children: React.ReactNode }) => {
  const [loggedIn, setLoggedIn] = React.useState(
    Cookies.get("jwt_token") !== undefined
  );
  const token = Cookies.get("jwt_token");
  const decodedToken = token ? jwtDecode<JWTToken>(token) : undefined;
  const [player, setPlayer] = React.useState<Player | undefined>(
    decodedToken?.player
  );
  const [discordId, setDiscordId] = React.useState<string | undefined>(
    decodedToken?.discordId
  );

  return (
    <LoginContext.Provider
      value={{
        loggedIn,
        setLoggedIn,
        player,
        setPlayer,
        discordId,
        setDiscordId,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(LoginContext);
};

/**
 * Get the base API URL from runtime configuration.
 * Prefers window.APP_CONFIG (injected by nginx), falls back to localhost for dev.
 */
function getBaseApiUrl(): string {
  const fromWindow = window.APP_CONFIG?.BASE_API_URL;
  if (fromWindow && typeof fromWindow === 'string') return fromWindow;
  return 'http://localhost:5229';
}

export async function logout() {
  const baseUrl = getBaseApiUrl().replace(/\/$/, '');
  const req = await fetch(`${baseUrl}/logout`, {
    credentials: "include",
  });

  // Delete csrftoken.
  Cookie.remove("jwt_token");

  return req;
}
